export default __webpack_public_path__ + "static/media/palais-brussels.159b8886.png";